import { VariantService } from 'src/app/angularJS/services/variant/variant.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

export class VariantCopyController {

  public static $inject = [
    '$rootScope',
    '$state',
    '$stateParams',
    'variantService',
    'UserMessages',
    'ACTToolbarService'
  ];

  public variantCopy: InterACT.Interfaces.Catalogues.Variant;
  public variant: InterACT.Interfaces.Catalogues.Variant;

  constructor(
    private $rootScope,
    private $state: ng.ui.IStateService,
    private $stateParams,
    private variantService: VariantService,
    private UserMessages: UserMessagesService,
    private ActToolbarService: ACTToolbarService) {
    this.variant = <any>{
      name: ''
    };
    this.variantCopy = angular.copy(this.$stateParams.sourceVariant);
    this.activate();
  }

  public copyVariant = () => {
    this.$rootScope.showSpinner = true;
    return this.variantService.create(
      this.$stateParams.catalogueId,
      this.$stateParams.productId,
      angular.extend(this.variantCopy, this.variant)).then(() => {
        this.$rootScope.showSpinner = false;
        this.UserMessages.showToast('TOAST_MESSAGE.VARIANT.COPIED');
        this.exitCopyVariant();
      });
  }

  public exitCopyVariant = () => {
    this.$state.go('variants.list', {
      catalogueId: this.$stateParams.catalogueId,
      productId: this.$stateParams.productId
    });
  }

  public isNameValid = (value: string) => {
    return this.variantCopy.name !== value;
  }

  private activate() {
    this.$rootScope.showSpinner = false;
    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('Copy Variant');
    });
  }
}